<template>
    <div class="comment">
        <div class="header">
            <div class="mb-2">
                <div class="name">
                    {{ comment.valuer.name }}
                </div>
                <div>{{ comment.updated_at | formatDate }}</div>
            </div>
            <b-dropdown
                dropleft
                no-caret
                size="sm"
                variant="light"
                class="actions-button"
            >
                <template slot="button-content">
                    <div class="fa fa-ellipsis-v p-1" />
                </template>
                <b-dropdown-item @click="onClickEdit">{{
                    $t('form.button.edit')
                }}</b-dropdown-item>
                <b-dropdown-item @click="onClickDelete">{{
                    $t('form.button.delete')
                }}</b-dropdown-item>
            </b-dropdown>
        </div>
        <div>
            <b-form-textarea
                v-if="isEditing"
                size="sm"
                :rows="1"
                :max-rows="10"
                class="scroll"
                ref="textarea"
                :state="isValid"
                @blur="onBlurTextarea"
                v-model="$v.comment.content.$model"
            />
            <div class="comment-content" v-else>{{ comment.content }}</div>
            <div class="d-flex justify-content-end mt-1" v-if="isSaving">
                <small class="mr-1">{{ $t('form.button.saving') }}</small>
                <i class="fa fa-spinner fa-spin" />
            </div>
        </div>
        <hr v-if="showDivisor" />
    </div>
</template>
<script>
import { debounce } from 'lodash'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { proceedWithConfirmation } from '@/lib/sweet-alert'
import { deleteComment, updateComment } from '@/views/n-box/report/api'
export default {
    mixins: [validationMixin],
    props: {
        showDivisor: Boolean,
        comment: {
            type: Object,
            required: true,
        },
    },
    validations: {
        comment: {
            content: {
                required,
            },
        },
    },
    data() {
        return {
            isSaving: false,
            isEditing: false,
            lastCommentContent: '',
        }
    },
    mounted() {
        this.setLastCommentContent()
    },
    computed: {
        isValid() {
            return this.$v.$dirty ? !this.$v.$invalid : null
        },
    },
    watch: {
        'comment.content': debounce(function() {
            this.updateCommentContent()
        }, 500),
    },
    methods: {
        updateCommentContent() {
            if (!this.shouldUpdateContent()) {
                return
            }

            this.isSaving = true
            this.setLastCommentContent()

            updateComment(this.comment.id, {
                content: this.comment.content,
            }).finally(() => {
                this.isSaving = false
            })
        },
        setLastCommentContent() {
            this.lastCommentContent = this.comment.content
        },
        shouldUpdateContent() {
            const hasContent = this.comment.content.length > 0
            const isDifferent = this.comment.content !== this.lastCommentContent
            return hasContent && isDifferent
        },
        onClickDelete() {
            proceedWithConfirmation({
                onConfirm: () => deleteComment(this.comment.id),
                callback: () => this.$emit('deleted', this.comment.id),
            })
        },
        onClickEdit() {
            this.isEditing = true
            setTimeout(() => {
                this.$refs.textarea.focus()
            }, 50)
        },
        onBlurTextarea() {
            this.comment.content = this.lastCommentContent
            this.$v.$reset()
            this.isEditing = false
        },
    },
}
</script>
<style lang="sass" scoped>
::v-deep .actions-button
    margin-left: auto

    button
        height: 30px
        background-color: white
        border-color: white
        padding: 0

hr
    margin: 12px 0 12px 0

.comment
    margin-bottom: 10px

    .comment-content
        text-align: justify

    .header
        display: flex
        height: auto

        .name
            font-weight: bold
            text-align: justify
            margin-right: 10px
</style>
